
class IntegratorMappingListViewController extends MUIViewController
{
    static newInstance(): IntegratorMappingListViewController {
        let vc = new IntegratorMappingListViewController("integrator-mapping-list-view");
        vc.initWithResource("layout/setup/IntegratorMappingListView.html");
        return vc;
    }

    private addButton: MUIButton = null;    
    private tableView: UITableView = null;

    viewDidLoad() {
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, function() {
            this.addMapping();
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animate?) {
        super.viewWillAppear(animate);
        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableview) {
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview, section) {
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableview, indexPath: MIOIndexPath) {
        let cell = tableview.dequeueReusableCellWithIdentifier("IntegratorMappingCell") as IntegratorMappingListCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as IntegratorMappingInfo;
        cell.item = item;
        return cell;
    }

    didSelectCellAtIndexPath(tableView, indexPath: MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as IntegratorMappingInfo;
        if (item) {
            let vc = IntegratorMappingDetailViewController.newInstance();
            vc.mappingInfo = item;
            this.navigationController.pushViewController(vc, true);
        }
    }

    editingStyleForRowAtIndexPath(tableView: UITableView, indexPath: MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle: UITableViewCellEditingStyle, indexPath: MIOIndexPath) {
        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as IntegratorMappingInfo;
            DBHelper.deleteObjectFromMainContext(item, true);
        }
    }

    private _fetchedResultsController: MIOFetchedResultsController = null;
    set fetchedResultsController(value) {
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
        this._fetchedResultsController = value;
    }

    get fetchedResultsController() {
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("IntegratorMappingInfo", sortDescriptors, null);

        let frc = new MIOFetchedResultsController();
        frc.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        frc.delegate = this;
        frc.performFetch();

        this._fetchedResultsController = frc;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller) {
        this.tableView.reloadData();
    }

    private addMapping() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(
            MIOLocalizeString("NEW_INTEGRATOR_MAPPING", "NEW INTEGRATOR MAPPING"),
            MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"),
            MUIAlertViewStyle.Default
        );

        avc.addTextFieldWithConfigurationHandler(this, function(textField: MUITextField) {
            textField.setPlaceholderText(MIOLocalizeString("NAME", "NAME"));
        });

        avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox) {
            comboBox.addItem("BANK IMPORTER")
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD", "ADD"), MUIAlertActionStyle.Default, this, function() {
            let name = avc.textFields[0].text.trim();
            if (name.length > 0) {
                let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
                let mapping = MIOEntityDescription.insertNewObjectForEntityForName("IntegratorMappingInfo", ad.managedObjectContext) as IntegratorMappingInfo;
                mapping.identifier = MIOUUID.UUID().UUIDString;
                mapping.name = name;
                mapping.type = "bank-importer";
                ad.managedObjectContext.save();
            }
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }
}
